import React from 'react';
import useToggle from '../../Hooks/useToggle';
import BackToTop from '../BackToTop';
import FooterHomeOne from '../HomeOne/FooterHomeOne';
import Drawer from '../Mobile/Drawer';
import HeaderNews from '../News/HeaderNews';
import HeroNews from '../News/HeroNews';

// Shared layout for the legal pages: red page banner, then the policy text
// (static HTML we own, see privacyPolicy.js / termsOfService.js)
function LegalPage({ title, path, html }) {
    const [drawer, drawerAction] = useToggle(false);

    return (
        <>
            <Drawer drawer={drawer} action={drawerAction.toggle} />
            <HeaderNews drawer={drawer} action={drawerAction.toggle} />
            <HeroNews
                title={title}
                breadcrumb={[
                    { link: '/', title: 'home' },
                    { link: path, title },
                ]}
            />
            <section className="dd-legal pt-90 pb-90">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div
                                className="dd-legal-content"
                                // eslint-disable-next-line react/no-danger
                                dangerouslySetInnerHTML={{ __html: html }}
                            />
                        </div>
                    </div>
                </div>
            </section>
            <FooterHomeOne />
            <BackToTop />
        </>
    );
}

export default LegalPage;
